// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Sb8","toggle":"styles_toggle__3wKHP","preview":"styles_preview__1ZHUF"};